var smartquotes = require("smartquotes");

smartquotes(document.getElementById("main-content"));
